<template>
  <div class="wrapper">
    <admin-title :title="$route.meta.name"></admin-title>
    <el-button
      style="margin-bottom:20px;"
      type="primary"
      icon="el-icon-plus"
      size="small"
      @click="goAdd"
    >添加</el-button>
    <!-- <div class="btn-group">
      <div></div>
      <div>
        <el-button type="primary" icon="el-icon-plus" size="small" @click="goAdd">添加</el-button>
      </div>
    </div> -->
    <tp-table
      :tableData="list"
      :columns="columns"
      :totalNum="total"
      :current-page.sync="currentPage"
      :pageSize.sync="pageSize"
    />
  </div>
</template>

<script>
import { dictListApi } from './api'

const columns = [
  {
    label: '字典名称',
    minWidth: '240',
    prop: 'name',
    customRender (h, row) {
      return (
        <p class="one-line" title={row['name']}>
          {row['name']}
        </p>
      )
    }
  },
  {
    label: '字典code值',
    minWidth: '240',
    prop: 'key',
    customRender (h, row) {
      return (
        <p class="one-line" title={row['key']}>
          {row['key']}
        </p>
      )
    }
  },
  {
    label: '备注',
    minWidth: '200',
    prop: 'remark',
    customRender (h, row) {
      return (
        <p class="one-line" title={row['remark']}>
          {row['remark']}
        </p>
      )
    }
  },
  {
    label: '操作',
    fixed: 'right',
    width: '250',
    customRender (h, row) {
      return (
        <div>
          <el-button type="primary" disabled={row['isDefault'] == 1} size="mini" icon="el-icon-edit" onClick={() => this.goEdit(row['id'])}>
            编辑
          </el-button>
          <el-button type="warning" size="mini" icon="el-icon-edit" onClick={() => this.goAddDictValue(row['key'], row['name'])}>
            添加字典值
          </el-button>
        </div>
      )
    }
  }
]
export default {
  data () {
    return {
      columns,
      list: [],
      total: 0,
      currentPage: 1,
      pageSize: 20
    }
  },
  mounted () {
    this.getList()
  },
  provide () {
    return {
      context: this
    }
  },
  watch: {
    currentPage () {
      this.getList()
    },
    page_size () {
      this.getList()
    }
  },
  methods: {
    async getList () {
      let params = {
        page: this.currentPage,
        pageSize: this.pageSize
      }
      const res = await dictListApi(params)
      this.list = res.data || []
      this.total = res.total || 0
    },

    goAdd () {
      this.$router.push({ name: 'dictManageAddOrEdit' })
    },
    goEdit (id) {
      this.$router.push({ name: 'dictManageAddOrEdit', params: { id: id || undefined } })
    },
    goAddDictValue (dictCode, dictName) {
      this.$router.push({ name: 'DictValueManage', query: { dictCode: dictCode || undefined, dictName: dictName || undefined } })
    },
    goRemove (id) {
      console.log(id)
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
  min-width: 800px;
  ::v-deep.one-line {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin: 0;
  }
  .el-table__body-wrapper {
    width: 100%;
  }
  .el-form {
    display: flex;
    justify-content: space-between;
    align-items: center;
    ::v-deep.el-form-item {
      margin-bottom: 0;
    }
  }
  .header {
    display: flex;
    justify-content: space-between;
  }
  .btn-group {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
  }
}
</style>
